import * as React from 'react'
import AdjustButton from './AdjustButton'
import { minutesToTime } from '../helpers/time'

export type RecordTimeProps = {
  time: any
  onAdjust?: (time: any) => void
  className?: string
}

const RecordTime: React.FC<RecordTimeProps> = ({ time, onAdjust, className }) => {
  const timeStr = minutesToTime(time.time)
  const details = [`${timeStr}`, `${time.worktype.code} - ${time.worktype.title}`, time.comment].filter(Boolean).join(', ')

  return (
    <div className={`card ${className || ''}`}>
      <div className="card-body p-2 d-flex justify-content-between align-items-center">
        <span>{details}</span>
        {onAdjust && <AdjustButton onClick={() => onAdjust(time)} />}
      </div>
    </div>
  )
}

export default RecordTime
